import { Divider, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { createSearchParams, useNavigate, useParams } from 'react-router-dom';
import CancelButton from '../../components/CancelButton';
import Head from '../../components/Head';
import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Radio from '../../components/UI/Radio';
import SelectInput from '../../components/UI/SelectInput';
import SmartSearch from '../../components/UI/SmartSearch';
import SwitchInput from '../../components/UI/SwitchInput';
import { createOrUpdateCharity, getCharityById } from '../../services/charities';
import { notificationError } from '../../services/notification';
import { onlyLetters, onlyNumbers } from '../../utils/formValidation';
import { findRelativeStatus } from '../../utils/objectUtils';
import { onlyNumbersAsString, validateEmailsByComma } from '../../utils/stringUtils';
import { InputMode } from '../../enums/inputTypeEnum';

function NewCharity() {
  const history = useNavigate()
  const {id} = useParams()
  const statusSelectOptions = [
    {label: 'Active', value: 'ACTIVE'},
    {label: 'Closed', value: 'CLOSED'},
    {label: 'Inactive', value: 'INACTIVE'}
  ]
  const [distributor, setDistributor] = useState('')
  const [form, setForm] = useState({
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: statusSelectOptions[0].value,
    disableDeckManagement: false,
    businessName: "",
    customerId:"",
    distributorId: '',
  })
  const [orig, setOrig] = useState({
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: statusSelectOptions[0].value,
    disableDeckManagement: false,
    businessName: "",
    customerId:"",
    distributorId: '',
  })

  useEffect(()=> {
    (async () => {
      if(id) {
        const response = await getCharityById({id: id})
        setForm({
          name: response.name,
          address: response.address,
          zipcode: response.zipcode,
          city: response.city,
          state: response.state,
          phone: response.phone,
          email: response.email,
          status: findRelativeStatus(response.status, statusSelectOptions),
          disableDeckManagement: response.disableDeckManagement,
          businessName: response.businessName,
          customerId: response.customerId,
          distributorId: response.distributorId
        })
        setOrig({
          name: response.name,
          address: response.address,
          zipcode: response.zipcode,
          city: response.city,
          state: response.state,
          phone: response.phone,
          email: response.email,
          status: findRelativeStatus(response.status, statusSelectOptions),
          disableDeckManagement: response.disableDeckManagement,
          businessName: response.businessName,
          customerId: response.customerId,
          distributorId: response.distributorId
        })
        setDistributor(response.distributorName)
      }
    })()
  },[])

  const isChanged = () => {

    if(!form.name
        || !form.address
        || !form.zipcode
        || !form.city
        || !form.state
        || !form.phone
        || !form.email
        || !form.status
        || !form.businessName
        || !form.customerId
        || !form.distributorId
    ) return false
    if(form.address!==orig.address) return true
    if(form.name!==orig.name) return true
    if(onlyNumbersAsString(form.zipcode)!==onlyNumbersAsString(orig.zipcode)) return true
    if(form.city!==orig.city) return true
    if(form.state!==orig.state) return true
    if(onlyNumbersAsString(form.phone)!==onlyNumbersAsString(orig.phone)) return true
    if(form.email!==orig.email) return true
    if(form.state!==orig.state) return true
    if(form.status!==orig.status) return true
    if(form.disableDeckManagement!==orig.disableDeckManagement) return true
    if(form.businessName!==orig.businessName) return true
    if(form.distributorId!==orig.distributorId) return true
    return form.customerId !== orig.customerId;

  }

  const submit = async () => {
    const phone = onlyNumbersAsString(form.phone)
    const zipcode = onlyNumbersAsString(form.zipcode)
    const {validEmails, invalidEmails} = validateEmailsByComma(form.email)

    if(!form.name) return notificationError('Please insert name')
    if(!form.address) return notificationError('Please insert address')
    if(zipcode.length < 5 || zipcode.length > 9 ) return notificationError('Zipcode must have between 5 and 9 characters and only numbers')
    if(!form.city) return notificationError('Please insert city')
    if(!form.state) return notificationError('Please insert a state')
    if(!phone) return notificationError('Please insert a phone')
    if(phone.length < 10 || phone.length > 10 ) return notificationError('Phone must be 10 numbers')
    if(validEmails === 0) return notificationError('Please insert a valid email')
    if(invalidEmails > 0) return notificationError('Please insert only valid emails')
    if(!form.businessName) return notificationError('Please insert an MDOR business name')
    if(!form.customerId) return notificationError('Please insert a customer ID')
    if(form.customerId.length > 20 ) return notificationError('Customer ID must be 20 characters or less')
    if(!form.distributorId) return notificationError('Please select the distributor')
    if(id) await createOrUpdateCharity({id, ...form})
    if(!id) await createOrUpdateCharity(form)

    history({
      pathname:'/charities/',
      search: createSearchParams({
        useRecord: 'true'
      }).toString()
    })
  }

  return (
    <div className="new-distributor">
      <Head title={id ? 'Edit Charity' : 'New Charity'}/>
      <div className="new-distributor__container">
        <Divider orientation="left"><strong>General info</strong></Divider>
        <div className="new-distributor__container__row">
          <Input
            label="Name*"
            placeholder="Name"
            value={form.name}
            onChange={(e: any) => setForm({...form, name: e.target.value})}
          />
          <Input
            label="Address*"
            placeholder="Address"
            value={form.address}
            onChange={(e: any) => setForm({...form, address: e.target.value})}
          />
          <Input
            label="Zipcode*"
            placeholder="Zipcode"
            value={form.zipcode}
            onChange={(e: any) => setForm({...form, zipcode: onlyNumbers(e.target.value)})}
          />
          <Input
            label="City*"
            placeholder="City"
            value={form.city}
            onChange={(e: any) => setForm({...form, city: e.target.value})}
          />
          <Input
            label="State*"
            placeholder="State"
            value={form.state}
            onChange={(e: any) => e.target.value.length <= 2 && setForm({...form, state: onlyLetters(e.target.value)})}
            style={{width: 100}}
          />
          <Input
            onChange={(e) => setForm({...form, phone: e.target.value})}
            label='Phone*'
            placeholder='(000) 000-0000'
            value={form.phone || ''}
            inputMode={InputMode.PHONE}
          />
          <Input
            label="Emails (comma separated) *"
            style={{width: '440px'}}
            placeholder="Emails"
            value={form.email}
            onChange={(e: any) => setForm({...form, email: e.target.value})}
          />

          <Radio
            innerProps={{id:'new-charity-status'}}
            disabled={id ? true : false}
            label='Status*'
            value={form.status}
            onChange={(e: any) => setForm({...form, status: e.target.value})}
            options={statusSelectOptions} 
          />
          {(!id || id==="") &&
            <SmartSearch
            disabled={id ? true : false}
            label="Distributor *"
            searchBy={['distributor']}
            value={distributor}
            triggerWith={distributor}
            status="active"
            onChange={(e: any) => setDistributor(e)}
            onValidSearch={(e: any) => {}}
            onObjValueChange={(e) => setForm({...form, distributorId: e.id})}
          />}
          {id && id!=="" &&
              <Input
                  label="Distributor"
                  placeholder="Distributor"
                  value={distributor}
                  onChange={(e: any) => {}}
                  innerProps={{id:'new-charity-distributor'}}
                  disabled={true}
              />
          }
        </div>
        <Divider orientation="left"><strong>MDOR Export Settings</strong></Divider>
        <div className="new-distributor__container__row">
          <Input
            label="Business name*"
            placeholder="Business name"
            value={form.businessName}
            onChange={(e: any) => setForm({...form, businessName: e.target.value})}
          />
          <Input
            label="Customer ID *"
            placeholder="Customer ID"
            value={form.customerId}
            maxLength={10}
            onChange={(e: any) => setForm({...form, customerId: e.target.value})}
          />
        </div>
        <Divider orientation="left"><strong>Deck Management Screen</strong></Divider>
        <div className="new-distributor__container__row">
          <SwitchInput
            label="Allow Manufacturer And Distributor To Configure Decks At Decks Management Screen"
            options={{check: false, uncheck: true}}
            onChange={(e: any) => setForm({...form, disableDeckManagement: e})}
            value={form.disableDeckManagement}
          />
        </div>
        <Divider />
        <div className="new-distributor__container__actions">
          <CancelButton customRedirect={() => {
            history({
              pathname:'/charities/',
              search: createSearchParams({
                useRecord: 'true'
              }).toString()
            })
          }}/>
          <Button type="primary"
                  onClick={() => submit()}
                  disabled={!isChanged()}
          >
            <p id="save-button">Save</p>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NewCharity